import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { booleanArray2jdug9b51huk7 as booleanArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { get_EMPTY_SERIALIZER_ARRAY2gyuhuf2kalz as get_EMPTY_SERIALIZER_ARRAY } from './PluginHelperInterfaces.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compactArray1b2nl9rkq8nuz as compactArray } from './Platform.common.mjs';
import { CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance } from '../descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  getChecked1o70dkx10jwym as getChecked,
  getChecked3avs2psuwt1xd as getChecked_0,
} from './Platform.mjs';
import {
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_elementDescriptors13xxljc24xo44 as get_elementDescriptors,
} from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.childSerializers$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
  return tmp0.get_value_j01efc_k$();
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this._hashCode$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
  return tmp0.get_value_j01efc_k$();
}
function buildIndices($this) {
  var indices = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
  var inductionVariable = 0;
  var last = $this.names_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.names_1[i];
      indices.put_4fpzoq_k$(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
  return constructCallableReference((p0) => _get_childSerializers__7vnyfa(p0), 1, 0, 19);
}
function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
  return constructCallableReference((p0) => p0.get_typeParameterDescriptors_3o94ow_k$(), 1, 0, 20);
}
function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
  return constructCallableReference((p0) => _get__hashCode__tgwhef(p0), 1, 0, 21);
}
var PluginGeneratedSerialDescriptorClass;
function PluginGeneratedSerialDescriptor() {
  if (PluginGeneratedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, generatedSerializer, elementsCount) {
        generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
        this.serialName_1 = serialName;
        this.generatedSerializer_1 = generatedSerializer;
        this.elementsCount_1 = elementsCount;
        this.added_1 = -1;
        var tmp = this;
        var tmp_0 = 0;
        var tmp_1 = this.elementsCount_1;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_2 = Array(tmp_1);
        while (tmp_0 < tmp_1) {
          tmp_2[tmp_0] = '[UNINITIALIZED]';
          tmp_0 = tmp_0 + 1 | 0;
        }
        tmp.names_1 = tmp_2;
        var tmp_3 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.elementsCount_1;
        tmp_3.propertiesAnnotations_1 = Array(size);
        this.classAnnotations_1 = null;
        this.elementsOptionality_1 = booleanArray(this.elementsCount_1);
        this.indices_1 = emptyMap();
        var tmp_4 = this;
        var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_4.childSerializers$delegate_1 = lazy(tmp_5, () => {
          var tmp0_safe_receiver = this.generatedSerializer_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.childSerializers_5ghqw5_k$();
          return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
        });
        var tmp_6 = this;
        var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_6.typeParameterDescriptors$delegate_1 = lazy(tmp_7, () => {
          var tmp0_safe_receiver = this.generatedSerializer_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.typeParametersSerializers_fr94fx_k$();
          var tmp;
          if (tmp1_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp1_safe_receiver.length);
            var inductionVariable = 0;
            var last = tmp1_safe_receiver.length;
            while (inductionVariable < last) {
              var item = tmp1_safe_receiver[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              var tmp$ret$5 = item.get_descriptor_wjt6a0_k$();
              destination.add_utx5q5_k$(tmp$ret$5);
            }
            tmp = destination;
          }
          return compactArray(tmp);
        });
        var tmp_8 = this;
        var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_8._hashCode$delegate_1 = lazy(tmp_9, () => hashCodeImpl(this, this.get_typeParameterDescriptors_3o94ow_k$()));
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      get_elementsCount_288r0x_k$() {
        return this.elementsCount_1;
      }
      get_kind_wop7ml_k$() {
        return CLASS_getInstance();
      }
      get_annotations_20dirp_k$() {
        var tmp0_elvis_lhs = this.classAnnotations_1;
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      }
      get_serialNames_8zf3cl_k$() {
        return this.indices_1.get_keys_wop4xp_k$();
      }
      get_typeParameterDescriptors_3o94ow_k$() {
        var tmp0 = this.typeParameterDescriptors$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
        return tmp0.get_value_j01efc_k$();
      }
      addElement_5pzumi_k$(name, isOptional) {
        this.added_1 = this.added_1 + 1 | 0;
        this.names_1[this.added_1] = name;
        this.elementsOptionality_1[this.added_1] = isOptional;
        this.propertiesAnnotations_1[this.added_1] = null;
        if (this.added_1 === (this.elementsCount_1 - 1 | 0)) {
          this.indices_1 = buildIndices(this);
        }
      }
      addElement$default_mty55e_k$(name, isOptional, $super) {
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
          this.addElement_5pzumi_k$(name, isOptional);
          tmp = Unit_instance;
        } else {
          tmp = $super.addElement_5pzumi_k$.call(this, name, isOptional);
        }
        return tmp;
      }
      pushAnnotation_fm15ho_k$(annotation) {
        // Inline function 'kotlin.let' call
        var it = this.propertiesAnnotations_1[this.added_1];
        var tmp;
        if (it == null) {
          var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(1);
          this.propertiesAnnotations_1[this.added_1] = result;
          tmp = result;
        } else {
          tmp = it;
        }
        var list = tmp;
        list.add_utx5q5_k$(annotation);
      }
      pushClassAnnotation_xtmllk_k$(a) {
        if (this.classAnnotations_1 == null) {
          this.classAnnotations_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(1);
        }
        ensureNotNull(this.classAnnotations_1).add_utx5q5_k$(a);
      }
      getElementDescriptor_ncda77_k$(index) {
        return getChecked(_get_childSerializers__7vnyfa(this), index).get_descriptor_wjt6a0_k$();
      }
      isElementOptional_heqq56_k$(index) {
        return getChecked_0(this.elementsOptionality_1, index);
      }
      getElementAnnotations_omrjs6_k$(index) {
        var tmp0_elvis_lhs = getChecked(this.propertiesAnnotations_1, index);
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      }
      getElementName_u4sqmf_k$(index) {
        return getChecked(this.names_1, index);
      }
      getElementIndex_utfbym_k$(name) {
        var tmp0_elvis_lhs = this.indices_1.get_wei43m_k$(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof PluginGeneratedSerialDescriptor())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.get_serialName_u2rqhk_k$() === other.get_serialName_u2rqhk_k$())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!contentEquals(this.get_typeParameterDescriptors_3o94ow_k$(), other.get_typeParameterDescriptors_3o94ow_k$())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.get_elementsCount_288r0x_k$() === other.get_elementsCount_288r0x_k$())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.get_elementsCount_288r0x_k$();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.getElementDescriptor_ncda77_k$(index).get_serialName_u2rqhk_k$() === other.getElementDescriptor_ncda77_k$(index).get_serialName_u2rqhk_k$())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.getElementDescriptor_ncda77_k$(index).get_kind_wop7ml_k$(), other.getElementDescriptor_ncda77_k$(index).get_kind_wop7ml_k$())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        return _get__hashCode__tgwhef(this);
      }
      toString() {
        return toStringImpl(this);
      }
    }
    protoOf($).get_isNullable_67sy7o_k$ = get_isNullable;
    protoOf($).get_isInline_usk17w_k$ = get_isInline;
    initMetadataForClass($, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    PluginGeneratedSerialDescriptorClass = $;
  }
  return PluginGeneratedSerialDescriptorClass;
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.get_serialName_u2rqhk_k$());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = elementDescriptors.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = element.get_serialName_u2rqhk_k$();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var _iterator__ex2g4s_0 = elementDescriptors.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = element_0.get_kind_wop7ml_k$();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function toStringImpl(_this__u8e3s4) {
  var tmp = until(0, _this__u8e3s4.get_elementsCount_288r0x_k$());
  var tmp_0 = _this__u8e3s4.get_serialName_u2rqhk_k$() + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, (i) => _this__u8e3s4.getElementName_u4sqmf_k$(i) + ': ' + _this__u8e3s4.getElementDescriptor_ncda77_k$(i).get_serialName_u2rqhk_k$());
}
//region block: exports
export {
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  hashCodeImpl as hashCodeImplfv8qiy3re24s,
  toStringImpl as toStringImpl1y3u8fza7vdq,
};
//endregion

//# sourceMappingURL=PluginGeneratedSerialDescriptor.mjs.map
